import { render, staticRenderFns } from "./cookie-disclaimer.vue?vue&type=template&id=06435b4a&"
import script from "./cookie-disclaimer.vue?vue&type=script&lang=js&"
export * from "./cookie-disclaimer.vue?vue&type=script&lang=js&"
import style0 from "./cookie-disclaimer.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports